import { DOMParser as ProseMirrorDOMParser, Fragment, Slice } from "prosemirror-model";

const addInsertedMarkToText = (node, insertedMark) => {
  if (node.isText) {
    return node.mark(insertedMark.addToSet(node.marks));
  }

  if (node.isLeaf) return node;

  const children = [];
  node.content.forEach((child) => {
    children.push(addInsertedMarkToText(child, insertedMark));
  });
  return node.copy(Fragment.fromArray(children));
};

/**
 * Parse card HTML before applying the inserted mark. Wrapping the source HTML
 * in span.inserted makes that mark cover hardBreak nodes too, changing the DOM
 * from a bare <br> to <span class="inserted"><br></span>. Applying the mark to
 * text nodes after parsing keeps the source block/break structure unchanged.
 */
export function buildCardHtmlInsertionSlice(editor, html, colored = true) {
  const container = document.createElement("div");
  container.innerHTML = html;
  const parsed = ProseMirrorDOMParser.fromSchema(editor.schema).parseSlice(container);

  const insertedMarkType = colored ? editor.schema.marks.inserted : null;
  if (!insertedMarkType) return parsed;

  const insertedMark = insertedMarkType.create();
  const nodes = [];
  parsed.content.forEach((node) => {
    nodes.push(addInsertedMarkToText(node, insertedMark));
  });

  return new Slice(Fragment.fromArray(nodes), parsed.openStart, parsed.openEnd);
}

/** Inserts parsed card HTML and its text marks in one transaction/undo step. */
export function insertCardHtml(editor, html, colored = true) {
  const slice = buildCardHtmlInsertionSlice(editor, html, colored);
  const tr = editor.state.tr.replaceSelection(slice).scrollIntoView();
  const toPos = tr.selection.from;
  editor.view.dispatch(tr);
  return toPos;
}
